module.exports = __webpack_public_path__ + "img/arrowdown.8427557b.png";